import { render, staticRenderFns } from "./DigitalRejection.vue?vue&type=template&id=32d85b09&scoped=true&"
import script from "./DigitalRejection.vue?vue&type=script&lang=js&"
export * from "./DigitalRejection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d85b09",
  null
  
)

export default component.exports